import React from 'react';
import TagRescheduled from '../modules/events/components/TagRescheduled';
import Tag from '../reusables/Tag';
import TagFeatured from '../modules/events/components/TagFeatured';
import { CardText1 } from '../modules/events/components/body/EventsBodyStyled';

interface EventTagsProps {
  isToday?: boolean;
  isFeatured?: boolean;
  isRescheduled?: boolean;
  name?: string;
  color?: string;
  isSubscribed?: boolean;
}

const EventTags: React.FC<EventTagsProps> = ({
  isToday,
  isFeatured,
  isRescheduled,
  name,
  color,
  isSubscribed
}) => (
  <div className="tags">
    {isToday && <CardText1>Hoy</CardText1>}
    {isFeatured && <TagFeatured />}
    {isRescheduled && <TagRescheduled isRescheduled={isRescheduled} />}
    {name && name !== 'Inscrito' && (
      <Tag color={color ?? '#000'} title={name} weight="400" />
    )}
    {isSubscribed && <Tag color="#005C27" title="Inscrito" weight="400" />}
  </div>
);

export default EventTags;
